import { Box } from "@chakra-ui/react";

import {
  colors,
  getCdnImageSrc,
  HStack,
  VStack,
  Image,
  Spacing,
} from "goi_common";

export function CarouselCard({ title, contents }: any) {
  // contents가 배열이 아닌 경우 빈 배열로 처리
  const contentsArray = Array.isArray(contents) ? contents : [];

  return (
    <VStack
      gap={18}
      width="100%"
      background={colors.warmGray150}
      padding="0 16px 20px"
      borderRadius="10px"
    >
      <VStack
        gap={6}
        background={colors.white}
        margin="36px 0 0 0"
        padding="10px 12px"
        borderRadius="5px"
        alignItems="center"
      >
        <div className="subtitle_16_b black">{title}</div>
      </VStack>

      <HStack gap={"12px"} css={{ overflowX: "scroll" }} width="100%">
        {contentsArray.map((content: any) => (
          <>
            <VStack
              gap="10px"
              style={{ minWidth: "45%" }}
              key={content.title}
              position="relative"
            >
              <Image
                src={getCdnImageSrc(content.src)}
                width="184px"
                alt={content.title}
              />
              <VStack height="100%" justifyContent="space-between">
                <Box className={"subtitle_16_b"}>{content.title}</Box>
                <Box className="body_14_m gray700">{content.descriptions}</Box>

                {content.discountPrice ? (
                  <VStack position="relative" css={{ marginTop: "auto" }}>
                    <Box className={"subtitle_16_b gray900"}>
                      {typeof content.discountPrice === "number" ? (
                        <>{content.discountPrice.toLocaleString()} 원</>
                      ) : (
                        <>{content.discountPrice}</>
                      )}
                    </Box>
                  </VStack>
                ) : (
                  <Box
                    className={"subtitle_16_b gray900"}
                    css={{ marginTop: "auto" }}
                  >
                    {content.price === 0 ? (
                      <>무료 제공</>
                    ) : (
                      <>{content.price.toLocaleString()} 원 </>
                    )}
                  </Box>
                )}
                <Spacing gap={20} />
              </VStack>
            </VStack>
          </>
        ))}
      </HStack>
    </VStack>
  );
}
